// zh.js
const zh_CN = {
  "首页": "首页",
  '收藏': '收藏',
  home: {
    "GLOBAL INDUSTRIAL INTELLIGENCE TRADING PLATFORM": "全球工业化智能交易平台",
    "设备分类": "设备分类",
    "请输入内容": "请输入内容",
    "请输入关键词": "请输入关键词",
    "搜索": "搜索",
    "供应大厅": "供应大厅",
    "查看更多": "查看更多",
    "采购大厅": "采购大厅",
    "截止日期": "截止日期",
    "交货期限": "交货期限",
    "数量": "数量",
    "去询价": "去询价",
    "平台介绍": "平台介绍",
    "新闻动态": "新闻动态",
    "产品名称": "产品名称",
    "产品描述": "产品描述",
    "供应商": "供应商",
    "月供应量": "月供应量",
    "物流方式": "物流方式",
    "询价": "询价",
    "平台介绍详情": "打造\"一套标准、两个生态、三大资产\"，以航空工业品进出口贸易为主，依托珠海航展，作业务延伸，使航展贸易常态化、数字化、国际化，目标成为世界一流的航空工业商贸综合服务平台。",
    "琴航航空工业品平台": "琴航航空工业品平台",
    "推荐品牌": "推荐品牌",
	"推荐":'推荐',
    "全球工业化智能解决方案": "全球工业化智能解决方案",
    "二手飞机推荐": "二手飞机推荐",
    "供求大厅": "供求大厅",
    "更多供求": "更多供求",
	"全面定制化供应链服务": "全面定制化供应链服务",
    "立即体验AI助手": "立即体验AI助手",
    "AI助手": "AI助手"
  },
  aiObject: {
    "title": "AI智能助手",
    "connected": "已连接",
    "placeholder": "请输入您的问题",
    "send": "发送",
    "stop": "停止生成",
    "clear": "清除记录",
    "welcome": "您好！我是AI智能助手，有什么可以帮助您的吗？",
    "thinking": "正在思考中...",
    "error": "抱歉，我暂时无法回答您的问题，请稍后再试。",
    "networkError": "抱歉，网络连接出现问题，请稍后再试。",
    "stopped": "生成已停止",
    "confirmClose": "AI助手正在生成中，确定要关闭吗？",
    "notice": "提示",
    "confirm": "确定",
    "cancel": "取消"
  },
  PageHeader: {
    "首页": "首页",
    "供应大厅": "供应大厅",
    "采购大厅": "采购大厅",
    "二手飞机库": "二手飞机库",
    "备件商城": "备件商城",
    "招采平台": "招采平台",
    "解决方案": "解决方案",
    "新闻中心": "新闻中心",
    "关于我们": "关于我们",
    "简体中文": "简体中文",
    "登录/注册": "登录/注册",
    "欢迎您走进琴航科技": "欢迎您走进琴航科技",
	"已退出登录":'已退出登录'
  },
  reservation: {
    "预约": "预约",
    
    // 头部横幅文本
    "title1": "在IDEF展会遇见连接科技",
    "title2": "2025",
    "title3": "国防工业所有参与者齐聚一堂",
    "title4": "2025年7月22-27日 - 展位8-C14A",
    
    // 内容描述段落
    "desc1": "IDEF 2025第17届国际国防工业博览会将由土耳其共和国国防部主办，在土耳其共和国总统府国防工业秘书处的支持下，由土耳其武装部队基金会管理和负责，KFA博览会组织公司承办，于2025年7月22-27日在伊斯坦布尔博览中心举行。",
    "desc2": "加入连接科技及合作伙伴",
    "desc2_link": "贝尼尔",
    "desc2_cont": "在展位8-C14A。作为NVIDIA精英合作伙伴，连接科技的产品包括适用于有人和无人应用的小型、低功耗、加固解决方案。这些紧凑而强大的边缘设备可以轻松携带或部署到各种车辆上，在战术边缘提供实时决策。",
    "desc3": "立即预约会议，详细讨论您的应用并了解针对您特定设计要求的潜在解决方案。",
    "desc4": "请填写表格以安排您的会议。",
    "required_note": "必填字段",
    
    // 表单标签
    "label_salutation": "称谓：",
    "label_first_name": "名字：",
    "label_last_name": "姓氏：",
    "label_email": "邮箱：",
    "label_job_title": "职位：",
    "label_company": "公司：",
    "label_phone": "电话：",
    "label_country": "国家：",
    "label_message": "留言：",
    
    // 占位符文本
    "ph_choose": "—请选择选项—",
    "ph_first_name": "请输入您的名字",
    "ph_last_name": "请输入您的姓氏",
    "ph_email": "请输入您的邮箱",
    "ph_job_title": "请输入您的职位",
    "ph_company": "请输入您的公司",
    "ph_phone": "请输入您的电话号码",
    "ph_country": "请输入您的国家",
    "ph_message": "请输入您的留言或具体要求",
    
    // 按钮和状态文本
    "btn_submit": "提交",
    "btn_submitting": "提交中...",
    "msg_success": "预约提交成功！我们会尽快联系您。",
    "msg_validation": "请正确填写所有必填字段",
    "msg_error": "提交预约失败，请重试。"
  },
  CommonFooter: {
    "琴航（广东横琴）科技有限公司": "琴航（广东横琴）科技有限公司",
    "400-000-0000": "400-000-0000",
    "地址：珠海市香洲区厚朴道398号横琴国际科技创新中心 7栋708-2": "地址：珠海市香洲区厚朴道398号横琴国际科技创新中心 7栋708-2",
    "contactEmail": "Mail：Kinghang@e99.cn",
    "关于我们": "关于我们",
    "供应大厅": "供应大厅",
    "需求大厅": "需求大厅",
    "解决方案": "解决方案",
    "增值服务": "增值服务",
    "服务": "服务",
    "帮助中心": "帮助中心",
    "平台规则": "平台规则",
    "常见问题": "常见问题",
    "安全保障": "安全保障",
    "联系我们": "联系我们",
    "© 2025 琴航（广东横琴）科技有限公司   版权所有  粤ICP备2025393208号-1": "© 2025 琴航（广东横琴）科技有限公司   版权所有  粤ICP备2025393208号-1",
    "热门产品分类": "热门产品分类",
    "智能无人机制造": "智能无人机制造",
    "无人机": "无人机",
    "螺旋桨": "螺旋桨",
    "RC电子配件": "RC电子配件",
    "起落架和收起": "起落架和收起",
    "碳纤维材料": "碳纤维材料",
    "无人机遥控器": "无人机遥控器",
    "帮助与支持": "帮助与支持",
    "关于琴航": "关于琴航",
    "了解琴航": "了解琴航",
    "加入琴航": "加入琴航",
    "投资者关系": "投资者关系",
    "可持续发展": "可持续发展",
    "廉洁举报": "廉洁举报",
    "新闻动态": "新闻动态",
    "琴航资讯": "琴航资讯",
    "行业动态": "行业动态",
    "最新科技": "最新科技",
    "Copyright © 2025 琴航（广东横琴）科技有限公司": "Copyright © 2025 琴航（广东横琴）科技有限公司",
    "版权所有": "版权所有",
	"使用条款": "使用条款",
	"粤ICP备2025393208号-1": "粤ICP备2025393208号-1",
	"网站地图": "网站地图",
	
	"元器件": "元器件",
	"应急装备": "应急装备",
	"光学传感器": "光学传感器",
	"mems": "mems",
	"复合材料": "复合材料",
	"低空飞行器": "低空飞行器",
	"其他": "其他",
	
  },
  'product-list': {
    '条件查询': '条件查询',
    '设备分类': '设备分类',
    '运输方式': '运输方式',
    '产品标签': '产品标签',
    '供应商类型': '供应商类型',
    '商品名称': '商品名称',
    '全部': '全部',
    '供应商店铺': '供应商店铺',
    '自营店铺': '自营店铺',
    '请输入商品名称': '请输入商品名称',
    '搜索': '搜索',
    '重置': '重置',
    '共 {count} 个结果': '共 {count} 个结果',
    '发布时间': '发布时间',
    '查看次数': '查看次数',
    '取消收藏': '取消收藏',
    '收藏': '收藏',
    '询价': '询价',
    '人工询价': '人工询价',
    '智能询价': '智能询价',
    '暂无产品': '暂无产品',
    '解决方案应用': '解决方案应用',
    '您想要的产品': '您想要的产品',
  },
  'product-details': {
    '供应大厅': '供应大厅',
    '产品详情': '产品详情',
    '取消收藏': '取消收藏',
    '收藏': '收藏',
	'加入收藏': '加入收藏',
	'加入询盘': '加入询盘',
	'取消询盘': '取消询盘',
    '1V1专家咨询': '1V1专家咨询',
    '商品详情': '商品详情',
    '用户案例': '用户案例',
    '服务支持': '服务支持',
    '专家咨询': '专家咨询',
    '请留下您的联系方式，方便我们与您联系': '请留下您的联系方式，方便我们与您联系',
    '也可直接联系客服邮箱': '也可直接联系客服邮箱',
    '请输入您的联系方式': '请输入您的联系方式',
    '取 消': '取 消',
    '确 定': '确 定',
    '提交成功': '提交成功',
    '联系我们': '联系我们',
	"规格": "规格",
	"价格": "价格",
    "月供应量": "月供应量",
    "运输方式": "运输方式",
	
	"规格详情": "规格详情",
	"描述": "描述",
  },
  // 新增 purchase-list 对象
  'purchase-list': {
      '条件查询': '条件查询',
      '设备分类': '设备分类',
      '共 {count} 个设备': '共 {count} 个设备',
      '发布时间': '发布时间',
      '查看次数': '查看次数',
      '去咨询': '去咨询',
      '暂无产品': '暂无产品',
      '截止日期': '截止日期',
      '数量': '数量'
  },
  // 新增 purchase-details 对象
  'purchase-details': {
      '采购大厅': '采购大厅',
      '需求详情': '需求详情',
      '进行中': '进行中',
      '采购数量': '采购数量',
      '预算金额': '预算金额',
      '交货期限': '交货期限',
      '距离截止还剩': '距离截止还剩',
      '采购需求详情': '采购需求详情',
      '采购商详情': '采购商详情',
      '已认证': '已认证',
      '成立时间': '成立时间',
      '员工': '员工',
      '相关推荐': '相关推荐',
      '截止时间': '截止时间',
      '采购中': '采购中',
	  '数量': '数量',
      '已截止': '已截止',
      '天': '天',
  },
  // 新增 solution-details 对象
  solution:{
    安防光电类供应链:'安防光电类供应链',
    安防光电类供应链介绍:'安防光电类供应链',
    应急救援解决方案:'应急救援解决方案',
    应急救援解决方案介绍:'本方案基于平台消防应急救援的核心产品技术，以消防单兵守护系统为基础支撑模块，针对多场景应急救援需求，提供高效化、模块化、智能化的装备组合与全流程服务支持。',
    noticeTitle:'无人机供应链解决方案',
    description:'无论是机身、动力系统等单项需求，还是整机需求，我们都能以高效、优质的服务满足客户。',
    返回上页:'返回上页',
    '单项需求策略':'单项需求策略',
    整机需求策略:'整机需求策略',
    服务流程:'服务流程',
    质量保障与售后服务:'质量保障与售后服务',
    相关产品:'相关产品',
    产品详情:'产品详情',
    了解更多产品:'了解更多产品',
    更多产品:'更多产品',
    规格:'规格',
	深入了解:'深入了解',
	相关解决方案:'相关解决方案',
	查看详情:'查看详情',
	您当前位置:'您当前位置',
	'您当前位置：首页': '您当前位置：首页',
	  应用场景及解决方案:'应用场景及解决方案',
	  核心优势:'核心优势',
	  '核心优势描述':'方案通过整合智能化装备，适用液压破拆、水下救援、智能机器人、个体防护等先进装备，结合标准化操作流程与技术支持，构建覆盖"监测预警—快速响应—精准处置—安全保障—持续优化"的应急救援闭环体系，适用于城市救援、地震灾害、水域搜救、危化品事故等场景，实现救援效率与安全性的双重提升，最大限度减少人员伤亡和财产损失。',
	'基础模块：消防单兵守护系统':'基础模块：消防单兵守护系统',
	  '消防单兵守护系统定位':'消防单兵守护系统定位',
	  '消防单兵守护系统定位描述':'消防单兵守护系统是应急救援的核心安全保障，通过集成定位、监测、通讯功能，为救援人员提供实时生命安全保障，并为指挥中心提供精准数据支持。',
	  '功能模块与产品组成':'功能模块与产品组成',
	  '功能模块':'功能模块',
	  '对应产品/技术':'对应产品/技术',
	  '技术参数与用途':'技术参数与用途',
	  '系统优势':'系统优势',
	  '应用场景':'应用场景',
    // solutionList 相关翻译
    机身: '机身',
    机身描述: '专业内知名的机身制造商合作，提供多种<br>材质（如碳纤维、铝合金）和结构设计的<br>机身选择，满足不同性能和应用场景需求。<br>客户可根据自身对重量、强度、耐腐蚀性',
    动力系统: '动力系统',
    动力系统描述: '整合优质电池、电机、电子调速器和螺旋',
    飞控系统: '飞控系统',
    飞控系统描述: '携手具备先进技术的飞控研发企业，提供功<br>能强大、稳定可靠的飞控产品。具备多种飞<br>行模式，高精度传感器融合技术和智能避障<br>功能，可根据客户对飞行稳定性、灵活性和<br>自主性的需求定制飞控算法和功能。',
    传感器: '传感器',
    传感器描述: '与领先的传感器厂商合作，提供适配 GPS、<br>陀螺仪、加速度计、气压计等各类高精度<br>传感器。根据无人机的应用场景和性能要<br>求，为客户精准选型和搭配，如测绘无人<br>机创建 GPS 网格，保障无人机注重高度和<br>流量传感器的稳定性。',
    通信系统: '通信系统',
    通信系统描述: '联合专业通信设备供应商，提供不同频段、<br>传输距离和抗干扰能力的通信系统。包括<br>数传电台、图传设备等，保障无人机与地<br>面站之间稳定的数据和图像传输。可根据<br>客户对传输距离、数据速率和保密性的要<br>求进行定制。',
    任务载荷: '任务载荷',
    任务载荷描述: '对接众多任务载荷生产厂家，提供丰富多<br>样的选择，如高清摄像头用于机拍、多光<br>谱相机用于农业监测、红外热像仪用于安<br>全巡检等。根据客户的行业应用需求，定<br>制专业的任务载荷解决方案和集成服务。',
    // part21.vue solutionList 相关翻译
    摄像头模组: '摄像头模组',
    摄像头模组描述: '与全球知名光学厂商合作，提供高清（4K/8K）、低照度、宽动态范围（WDR）等多样化摄像头模组。支持定制化参数（如焦距、光圈、分辨率），适配室内外不同光照环境，并集成AI芯片实现人脸识别、行为分析等智能功能。',
    红外热成像设备: '红外热成像设备',
    红外热成像设备描述: '联合红外探测器制造商，提供非制冷型与制冷型热成像模组，分辨率覆盖160×120至1280×1024，测温精度达±1℃。支持全天候监控，适用于周界防护、火灾预警等场景，可定制测温范围和图像增强算法。',
    智能分析系统: '智能分析系统',
    智能分析系统描述: '整合AI算法企业资源，提供视频结构化分析、多目标跟踪、异常行为检测等软件解决方案。支持与摄像头深度集成，根据客户需求定制算法模型（如车牌识别、人群密度分析），优化边缘计算与云端协同能力。',
    存储与传输设备: '存储与传输设备',
    存储与传输设备描述: '对接存储设备供应商，提供高性能NVR（网络视频录像机）、分布式存储服务器及云存储方案，支持海量数据实时存取与加密备份。联合通信企业定制高带宽、低延迟网络传输方案（如5G、光纤），保障视频流稳定传输。',
    辅助设备: '辅助设备',
    辅助设备描述: '提供支架、防护罩、补光灯等配套设备，适配极端环境（如高温、暴雨、水下、防爆场景），延长设备使用寿命。',
    // part14.vue solutionList 相关翻译
    城市建筑坍塌救援: '城市建筑坍塌救援',
    城市建筑坍塌救援描述: '需求痛点：混凝土结构破拆效率低、二次坍塌风险高、狭小空间搜救难。',
    地震灾害救援: '地震灾害救援',
    地震灾害救援描述: '需求痛点：废墟环境复杂、重型装备运输难、余震风险高。',
    水域救援: '水域救援（洪涝/沉船事故）',
    水域救援描述: '需求痛点：水下能见度低、障碍物切割难、救援响应速度不足。',
    危化品泄露与火灾: '危化品泄露与火灾',
    危化品泄露与火灾描述: '需求痛点：爆炸风险高、有毒气体扩散快、传统灭火效率低。',
    // part4.vue strategyList 相关翻译
    需求沟通与方案定制: '需求沟通与方案定制',
    需求沟通与方案定制描述: '深入了解客户对无人机的使用场景（如航拍、物流、测绘等）、性能要求（续航、载重、精度等）、预算限制和特殊功能需求，制定详细、个性化的整机方案。',
    整合优质资源生产组装: '整合优质资源生产组装',
    整合优质资源生产组装描述: '从各零部件供应商处采购高质量组件，产格把控质量，按照行业标准和客户要求进行精细组装，确保整机性能。',
    全面测试与质量检测: '全面测试与质量检测',
    全面测试与质量检测描述: '进行飞行性能、可靠性、环境适应性等多项测试，依据国际和行业标准，对每架无人机进行严格质量检测，保证交付产品合格。',
    售后服务与技术支持: '售后服务与技术支持',
    售后服务与技术支持描述: '提供包括维修保养、零部件更换、软件升级和技术咨询的售后服务，建立快速响应机制，及时解决客户问题。',
    // part6.vue serviceFlowItems 相关翻译
    需求收集与分析: '需求收集与分析',
    需求收集与分析描述: '通过线上沟通、线下拜访等方式，详细了解客户需求，形成需求分析报告。',
    方案设计与报价: '方案设计与报价',
    方案设计与报价描述: '根据需求，设计符对性解决方案，提供包含产品规格、价格、交货期等内容的详细报价单。',
    合同签订与订单确认: '合同签订与订单确认',
    合同签订与订单确认描述: '与客户加商共签订合同，明确双方权利义务，确认订单细节。',
    采购与生产安排: '采购与生产安排',
    采购与生产安排描述: '向供应商采购零部件，协调生产进度，把控生产质量。',
    质量检测与测试: '质量检测与测试',
    质量检测与测试描述: '对零部件和整机进行多轮质量检测和飞行测试，确保产品达标。',
    包装运输与交付: '包装、运输与交付',
    包装运输与交付描述: '采用专业包装，选择合适运输方式，确保产品安全、及时交付。',
    售后服务: '售后服务',
    售后服务描述: '提供售后支持，定期回访客户，收集反馈，持续改进服务。',
    // part6.vue qualityServiceItems 相关翻译
    质量保障体系: '质量保障体系',
    质量保障体系描述: '建立严格的质量管控体系，从供应商选择、原材料采购到生产、检测、包装，各环节均遵循国际标准和行业规范。',
    售后服务团队: '售后服务团队',
    售后服务团队描述: '组建专业团队，提供7×24小时响应服务，通过电话、邮件、远程协助等方式解决客户问题。',
    售后内容: '售后内容',
    售后内容描述: '提供一定期限质保服务，质保期内免费维修或更换质量问题部件；提供操作培训和技术指导；建立零部件库存，确保及时供应。',
    // part22.vue strategyList 相关翻译
    需求沟通与方案定制2: '需求沟通与方案定制',
    需求沟通与方案定制描述2: '深入调研客户场景（如园区安防、交通枢纽监控、工业 涵盖硬件选型、软件平台、网络架构）的完整解决方案。',
    资源整合与系统集成: '资源整合与系统集成',
    资源整合与系统集成描述: '从核心组件（摄像头、红外模组）到配套设备（存储、供电）全链路采购，严格把控供应商资质与产品兼容性。完成硬件组装与软件调试，确保多设备协同运行。',
    联调测试与场景验证: '联调测试与场景验证',
    联调测试与场景验证描述: '模拟真实场景进行压力测试：包括图像清晰度、夜视效果、网络延迟、AI分析准确率等，优化系统稳定性与响应速度。',
    安装部署与运维支持: '安装部署与运维支持',
    安装部署与运维支持描述: '提供现场安装指导或远程技术支持，协助客户完成系统部署。建立运维响应机制，定期远程诊断设备状态，预防潜在故障。',

    // part12.vue features
    '技术领先性': '技术领先性',
    '技术领先性副标题': 'Technological leadership',
    '技术领先性描述': '轻量化设计、模块化组合、智能操控技术（如北斗定位、热成像监测）。',
    '场景全覆盖': '场景全覆盖',
    '场景全覆盖副标题': 'Full scene coverage',
    '场景全覆盖描述': '从城市建筑坍塌到水下救援，从危化品泄漏到森林火灾，均提供针对性装备组合。',
    '安全双保险': '安全双保险',
    '安全双保险副标题': 'Double safety insurance',
    '安全双保险描述': '装备防爆设计 + 单兵生命监测系统，双重保障救援人员安全。',
    '服务全周期': '服务全周期',
    '服务全周期副标题': 'Full service cycle',
    '服务全周期描述': '提供从设备配置、操作培训到售后维护的一站式支持。',
    '实时定位与导航': '实时定位与导航',
    '北斗三号融合终端': '北斗三号融合终端',
    '定位误差参数': '水平误差≤3m，垂直误差<0.5m，无信号区域支持短报文通信。',
    '生命体征监测': '生命体征监测',
    '单兵生命体征传感器': '单兵生命体征传感器（集成于防护服）',
    '生命体征参数': '实时监测心率、体温、血氧饱和度，异常值自动报警。',
    '环境风险感知': '环境风险感知',
    '手持式长波红外成像气体检测仪': '手持式长波红外成像气体检测仪',
    '气体检测参数': '检测16种有毒气体（CO、H₂S等），精度±1ppm。',
    '氧气余量监控': '氧气余量监控',
    '智能氧气瓶压力传感器': '智能氧气瓶压力传感器',
    '氧气监控参数': '实时显示剩余氧气时间，低压预警（阈值≤5MPa）。',
    '通讯与数据回传': '通讯与数据回传',
    '卫星电话融合终端': '卫星电话融合终端',
    '通讯参数': '支持语音通话、热成像画面实时传输至指挥中心。',
    '多维度安全防护': '多维度安全防护',
    '多维度安全防护描述': '从生理状态到环境风险，全覆盖式监测预警。',
    '轻量化集成设计': '轻量化集成设计',
    '轻量化集成设计描述': '总重量<2kg，不影响救援人员机动性。',
    '智能决策支持': '智能决策支持',
    '智能决策支持描述': 'AI算法自动分析数据，推送避险路径与急救建议。',
    '高层火灾': '高层火灾',
    '高层火灾描述': '通过北斗定位楼层位置，氧气余量预警防止窒息风险。',
    '化工爆炸': '化工爆炸',
    '化工爆炸描述': '气体检测仪实时报警，指挥中心远程调度撤离路线。',
    '地下隧道': '地下隧道',
    '地下隧道描述': '短报文功能保障无GPS信号下的通讯与定位。',
  },
  'solution-details': {
      '解决方案标题': '解决方案',
      '方案详情': '方案详情',
      '文章标题': '文章标题',
      '文章描述': '文章描述',
      '一站式数据资产管理': '一站式数据资产管理',
      '业务挑战': '业务挑战',
      '解决方案': '解决方案',
      '方案价值': '方案价值',
      '1V1专家咨询': '1V1专家咨询',
      '端到端解决方案，加速释放数据价值': '端到端解决方案，加速释放数据价值',
      '数据平台': '数据平台',
      '数据管理平台': '数据管理平台',
      '数据仓库': '数据仓库',
      '咨询流程': '咨询流程',
      '需求咨询': '需求咨询',
      '初步沟通': '初步沟通',
      '方案交流': '方案交流',
      '商务流程': '商务流程',
      '提交相关需求，描述业务背景': '提交相关需求，描述业务背景',
      '需求确认，对平台心疑惑，解决合作顾虑': '需求确认，对平台心疑惑，解决合作顾虑',
      '针对相关方案进行详述并就技术问题深讨': '针对相关方案进行详述并就技术问题深讨',
      '方案确定后，开始执行商务流程': '方案确定后，开始执行商务流程',
      '已截止': '已截止',
      '暂无数据': '暂无数据'
  },
  // 新增 news-list 对象
  'news-list': {
      '新闻中心': '新闻中心',
      '中国智造 走向世界': '中国智造 走向世界',
      '点击查看更多': '点击查看更多'
  },
  'news-details': {
    '新闻中心': '新闻中心',
    '新闻详情': '新闻详情',
    '发布日期': '发布日期',
	'平台信息': '平台信息'
},
'contact-us': {
    '标题': '联系我们',
    '展会介绍': '琴航（广东横琴）科技有限公司，作为航空航天工业品跨境一站式服务平台的领先企业，始终致力于为全球客户提供高效、专业的工业品解决方案。我们凭借深厚的行业积累和创新的服务模式，成功搭建起连接国际供应商与需求方的桥梁，助力全球航空航天产业的高效发展。在土耳其伊斯坦布尔等国际市场上，琴航科技已建立起广泛的合作网络，通过本地化服务团队和数字化平台，为客户提供从供应链管理到技术支持的全程服务。我们的服务涵盖航空航天零部件、设备及技术解决方案，确保每一环节都符合国际最高标准。未来，琴航科技将继续深化全球化布局，拓展新兴市场，为全球航空航天工业的发展注入新动力。我们期待与更多合作伙伴携手，共创辉煌，推动行业进步。',
    '电话': '电话',
    '邮箱': '邮箱：Kinghang@e99.cn',
    '图片描述': '联系我们 - 琴航科技参展IDEF国防工业展览会'
},
'about': {
  '关于我们': '关于我们',
  '更新时间': '更新时间：',
  		'新闻详情': '新闻详情',
  		'了解琴航': '了解琴航',
  		'琴航文化': '琴航文化',
  		'核心优势': '核心优势',
  		'股东背景': '股东背景',
  		'政策支持': '政策支持',
  		'展望未来': '展望未来',
  		'您当前的位置：首页': '您当前的位置：首页',
  		'用户昵称': '用户昵称',
  		// 模块1
  		'成立背景':'成立背景',
  		'txt1':'低空经济作为战略性新兴产业，潜力巨大，国家也在低空经济领域积极布局。近年来，航空工业品领域迅猛发展，涌现出一大批先进的科技公司，并形成了完整产业链，但关于航空工业品跨境销售，仍处于起步阶段。',
  		'公司简介':'公司简介',
  		'txt2':'琴航科技是国内首个专注于航空航天工业品跨境一站式服务的平台，成立于2024年12月，旨在响应国家"双循环"战略，解决航空产业链企业在国外贸易方面的经验不足问题。',
  		'股东结构':'股东结构',
  		'txt3':'琴航科技的股东结构由珠海国资联合体主导，包括大横琴集团、珠海低空产业投资运营公司、珠海会展集团等。此外，全国工商联科技装备商会投资平台也参与其中，以强化资源整合能力。',
  		'团队力量':'团队力量',
  		'txt4':'核心团队成员均来自中国航天科技、保利防务、部队某机关单位、朗华集团等，在国内工业品领域有十余年以上的从业经验，具有丰富的海内外业内资源，从客户渠道、供应链、合规管理、政策法规、金融、物流等各方面具有扎实的业务基础。',
  		// 模块2
  		'战略定位':'战略定位',
  		'txt5':'以"一二三"发展模式引领企业发展，高质量打造"一套标准、两个生态、三大资产"，包括一套标准、两个生态（数字生态与产业生态）、三大资产（数据资产、技术资产、品牌资产）。核心使命是推动中国航空工业标准国际化，助力珠海成为航空产业链核心城市。',
  		'发展目标':'发展目标',
  		'txt6':'以航空工业品进出口贸易为主，致力于建设贸易常态化、数字化、国际化和建立完善的数据管理体系，将线上线下业务充分融合，通过大量贸易数据的积累以及深入挖掘行业潜力，助推中国航空工业能力提升及标准建设，向世界输出中国航空工业标准，成为国内领先、世界知名的航空工业品跨境贸易平台，推动粤港澳大湾区航空航天产业集聚，服务全球供应链。',
  		// 模块3
  		'txt7':'琴航科技的跨境贸易服务涵盖航空工业品进出口全流程（报关、物流、金融、合规等）。通过数据驱动，利用贸易数据积累，挖掘行业潜力，赋能产业链升级。',
  		'技术亮点':'技术亮点',
  		'txt8':'琴航科技的数字化平台整合航展资源，实现线上线下协同服务。同时，对标国际标准，推动中国航空工业技术认证与输出。',
  		'差异化优势':'差异化优势',
  		'txt9':'琴航科技的国资背景保障了资源的稳定性，全产业链服务降低了企业跨境门槛。',
  		'海外资源优势':'海外资源优势',
  		'txt10':'琴航科技的核心团队人员均有多年的对外交流合作经验和背景。同时，依托全联科装商会广泛的渠道资源，可提供国际供应链对接、市场拓展等服务。另一方面，作为跨境贸易平台，琴航在人员出入境管理上相较于大型国央企或涉及敏感行业、职业等更具有灵活性。',
  		'股东资源':'股东资源',
  		'txt11':'琴航珠海国资是集团在航空航天产业链战略布局上的重要一环；同时，依托中国航展资源，强化品牌与渠道优势。',
  		// 模块4
  		'横琴战略地位':'横琴战略地位',
  		'txt12':'琴航科技位于粤港澳深度合作区核心，享有跨境金融、税收等政策红利。毗邻澳门，是衔接国际市场的"超级口岸"。',
  		'政策赋能':'政策赋能',
  		'txt13':'琴航科技纳入《横琴总体发展规划》，支持高端制造与跨境服务创新。珠海市也在打造航空产业集群，琴航科技是其中的核心载体',
  		// 模块5
  		'短期规划':'短期规划',
  		'txt14':'琴航科技将完善平台功能，扩大跨境服务覆盖领域，如低空经济、无人机产业链等。',
  		'长期愿景':'长期愿景',
  		'txt15':'成为全球航空工业品贸易枢纽，推动中国标准与技术输出。同时，助力横琴建设"智能岛"，探索区块链、AI在跨境贸易中的应用。',
  		'txt16':'未来，大横琴集团将积极响应国家、省、市关于低空经济发展的有关部署，充分发挥珠海市和横琴粤澳深度合作区的政策与区位优势，全力支持琴航科技的建设和长远发展，立足珠海，服务全国，辐射全球，为推动国家低空经济发展、完善珠海航空航天产业链贡献坚实力量。',

  	'hotProducts': '热门产品分类',
  	'productCategories': `智能无人机制造<br>
  						 无人机<br>
  						 螺旋桨<br>
  						 RC电子配件`,

  	'helpSupport': '帮助与支持',
  	'platformRules': '平台规则',
  	'commonQuestions': '常见问题',
  	'securityGuarantee': '安全保障',
  	'contactUs': '联系我们',

  	'aboutQinhang': '关于琴航',
  	'aboutUs': '了解琴航',
  	'joinUs': '加入我们',
  	'investorRelations': '投资者关系',
  	'sustainability': '可持续发展',
  	'reportMisconduct': '廉洁举报',

  	'newsUpdates': '新闻动态',
  	'companyNews': '琴航资讯',
  	'industryTrends': '行业动态',
  	'latestTech': '最新科技',
  	'companyAddress': '地址：珠海市香洲区厚朴道398号横琴国际科技创新中心7栋708-2',
  	'copyright': `版权所有&nbsp;©&nbsp;2025&nbsp;琴航（广东横琴）科技有限公司&nbsp;&nbsp;|&nbsp;&nbsp;隐私权政策&nbsp;&nbsp;|&nbsp;&nbsp;使用条款&nbsp;&nbsp;|&nbsp;&nbsp;粤ICP备2025393208号-1&nbsp;&nbsp;|&nbsp;&nbsp;网站地图` ,
},
'collect-list': {
    "我的收藏": "我的收藏",
    "返回个人中心": "返回个人中心",
    "取消收藏": "取消收藏",
    "暂无产品": "暂无产品"
},
'shop-list': {
    "未提交购物车": "未提交购物车",
    "返回个人中心": "返回个人中心",
    "取消": "取消",
    "暂无产品": "暂无产品",
    '提交': '提交',
},
'submit-list': {
    "购物车提交记录": "购物车提交记录",
    "返回个人中心": "返回个人中心",
    "暂无提交记录": "暂无提交记录"
},
'submit-detail': {
    '购物车提交记录详情': '购物车提交记录详情',
    "返回购物车提交记录页": "返回购物车提交记录页",
},
'Card1': {
    '个人中心': '个人中心',
    '供应商': '供应商',
    '采购商': '采购商',
    '已完成企业认证': '已完成企业认证',
    '未完成企业认证': '未完成企业认证',
    '认证审核中': '认证审核中',
    '审核未通过,请重新认证': '审核未通过,请重新认证',
    '编辑资料': '编辑资料',
    '认证信息': '认证信息',
    '退出登录': '退出登录',
    '是否确认退出?': '是否确认退出?',
    '提示': '提示',
    '确定': '确定',
    '取消': '取消',
	'是否翻译':'是否翻译中文产品信息？',
	'翻译产品':'翻译产品'
},
'Card2': {
    '本月订单总额': '本月订单总额',
    '较上月增长': '较上月增长',
    '较上月降低': '较上月降低',
    '较上月无变化': '较上月无变化'
},
'Card3': {
    '待处理订单': '待处理订单',
    '查看详情': '查看详情'
},
'Card4': {
    '退货订单': '退货订单',
    '查看详情': '查看详情'
},
'Card5': {
    '我的订单': '我的订单',
    '查看全部': '查看全部',
    '待付款': '待付款',
    '待发货': '待发货',
    '待收货': '待收货',
    '收货完成': '收货完成',
    '退换货': '退换货'
},
'Card6': {
    '采购需求': '采购需求',
    '需求管理': '需求管理',
    '有效采购需求': '有效采购需求',
    '待审核需求': '待审核需求'
},
'Card7': {
    '账户安全': '账户安全',
    '安全等级': '安全等级',
    '企业认证': '企业认证',
    '已认证': '已认证',
    '未完成企业认证': '未完成企业认证',
    '审核未通过,请重新认证': '审核未通过,请重新认证',
    '认证审核中': '认证审核中',
    '高': '高',
},
'Card8': {
    '收藏夹': '收藏夹',
    '查看全部': '查看全部',
    '暂无收藏产品': '暂无收藏产品'
},
'Card9': {
    '消息中心': '消息中心',
    '查看全部': '查看全部',
    '订单发货通知': '订单发货通知',
    '您的订单 {orderId} 已发货': '您的订单 {orderId} 已发货',
    '{time} 前': '{time} 前'
},
'Card10': {
    '我的产品': '我的产品',
    '新增产品': '新增产品',
    '全部': '全部',
    '已上架': '已上架',
    '未上架': '未上架',
    '审核中': '审核中',
    '审核通过': '审核通过',
    '审核失败': '审核失败',
    '提交审核': '提交审核',
    '下架': '下架',
    '上架': '上架',
    '编辑': '编辑',
    '删除': '删除',
    '暂无产品': '暂无产品',
    '上传图片': '上传图片',
    '导入产品': '导入产品',
},
'Card11': {
    '我的产品': '我的产品',
    '新增需求': '新增需求',
    '返回个人中心': '返回个人中心',
    '全部': '全部',
    '审核中': '审核中',
    '审核通过': '审核通过',
    '审核失败': '审核失败',
    '提交审核': '提交审核',
    '编辑': '编辑',
    '删除': '删除',
    '暂无需求': '暂无需求',
    "已通过": "已通过",
    "审核中1": "审核中",
    "未通过": "未通过",
    "未审核": "未审核"
},
'Card12': {
    '我的订单': '我的订单',
    '返回个人中心': '返回个人中心',
    '所有订单': '所有订单',
    '待付款': '待付款',
    '待发货': '待发货',
    '已发货': '已发货',
    '收货完成': '收货完成',
    '退换货': '退换货',
    '暂无需求': '暂无需求',
    '提交审核': '提交审核',
    '编辑': '编辑',
    '删除': '删除',
    '退款': '退款'
},
'Card13': {
    '未提交购物车': '未提交购物车',
    '查看全部': '查看全部',
    '暂无产品': '暂无产品'
},
'Card14': {
    '购物车提交记录': '购物车提交记录',
    '查看全部': '查看全部',
    '暂无提交记录': '暂无提交记录'
},
'userEdit': {
    "修改个人信息": "修改个人信息",
    "头像": "头像",
    "用户名称": "用户名称",
    "同步登录账号": "同步登录账号",
    "手机号": "手机号",
    "邮箱": "邮箱",
    "请输入": "请输入",
    "请输入正确的手机号": "请输入正确的手机号",
    "请输入正确的邮箱": "请输入正确的邮箱",
    "提 交": "提 交",
    "修改成功": "修改成功"
},
'login': {
    '用户登录': '用户登录',
    '请输入用户名': '请输入用户名',
    '密码': '密码',
    '登录': '登录',
    '没有账户?立即注册': '没有账户?立即注册',
	
	'未登录或登录过期，请重新登录': '未登录或登录过期，请重新登录',
	'提示': '提示',
	'取消': '取消',
},
'register': {
  '用户注册': '用户注册',
  '已有账号，去登录': '已有账号，去登录',
  '用户名': '用户名',
  '邮箱': '邮箱',
  '密码': '密码',
  '再次输入密码': '再次输入密码',
  '用户类型': '用户类型',
  '采购商': '采购商',
  '供应商': '供应商',
  '注册': '注册',
  '请输入用户名称': '请输入用户名称',
  '请输入邮箱': '请输入邮箱',
  '请输入正确的邮箱格式': '请输入正确的邮箱格式',
  '请输入密码': '请输入密码',
  '请再次输入密码': '请再次输入密码',
  '请选择用户类型': '请选择用户类型'
},
'personalCenter': {
    '企业认证': '企业认证',
    '基本信息（必填）': '基本信息（必填）',
    '营业执照': '营业执照',
    '企业名称': '企业名称',
    '联系人': '联系人',
    '法定代表人身份证': '法定代表人身份证',
    '联系电话': '联系电话',
    '组织机构代码': '组织机构代码',
    '企业资质信息': '企业资质信息',
    '税务登记证': '税务登记证',
    '组织机构代码证': '组织机构代码证',
    '开户许可证': '开户许可证',
    '企业资质与能力': '企业资质与能力',
    '行业经营资质': '行业经营资质',
    '生产或代理资质': '生产或代理资质',
    '质量管理体系认证': '质量管理体系认证',
    '环保与安全资质': '环保与安全资质',
    '供货能力证明': '供货能力证明',
    '售后服务能力证明': '售后服务能力证明',
    '产品资质相关': '产品资质相关',
    '产品质量检测报告': '产品质量检测报告',
    '产品认证证书': '产品认证证书',
    '产品说明书': '产品说明书',
    '其他材料': '其他材料',
    '信用证明': '信用证明',
    '无违规声明': '无违规声明',
    '电商平台运营经验证明': '电商平台运营经验证明',
    '企业荣誉': '企业荣誉',
    '其他相关资质或证明材料': '其他相关资质或证明材料',
    '提交': '提交',
    '图片或文件': '图片或文件',
    '请上传营业执照': '请上传营业执照',
    '请输入企业名称': '请输入企业名称',
    '企业名称长度在2到50个字符之间': '企业名称长度在2到50个字符之间',
    '请输入联系人姓名': '请输入联系人姓名',
    '联系人姓名长度在2到20个字符之间': '联系人姓名长度在2到20个字符之间',
    '邮箱': '邮箱',
    '请输入邮箱地址': '请输入邮箱地址',
    '请输入联系电话': '请输入联系电话'
},
'personalCenter2': {
    '企业认证': '企业认证',
    '基本信息（必填）': '基本信息（必填）',
    '业务信息（必填）': '业务信息（必填）',
    '联系方式（必填）': '联系方式（必填）',
    '资质相关（必填）': '资质相关（必填）',
    '企业名称': '企业名称',
    '公司注册地址': '公司注册地址',
    '公司注册编号': '公司注册编号',
    '成立时间': '成立时间',
    '公司规模': '公司规模',
    '采购品类': '采购品类',
    '年采购额范围': '年采购额范围',
    '主要采购市场': '主要采购市场',
    '预计月采购量': '预计月采购量',
    '公司邮箱': '公司邮箱',
    '公司电话': '公司电话',
    '公司网站': '公司网站',
    '办公地址': '办公地址',
    '公司营业执照': '公司营业执照',
    '进出口贸易许可证': '进出口贸易许可证',
    '银行账户证明': '银行账户证明',
    '提交': '提交',
    '图片或文件': '图片或文件',
    '提交成功，请耐心等待客服审核通过': '提交成功，请耐心等待客服审核通过',
    '提示': '提示',
    '确定': '确定',
    '取消': '取消',
    '提交失败，请稍后重试': '提交失败，请稍后重试',
    '请完善必填信息': '请完善必填信息',
    '请输入企业名称': '请输入企业名称',
    '请输入公司注册地址': '请输入公司注册地址',
    '请输入公司注册编号': '请输入公司注册编号',
    '请选择成立时间': '请选择成立时间',
    '请选择公司规模': '请选择公司规模',
    '请选择采购品类': '请选择采购品类',
    '请选择年采购额范围': '请选择年采购额范围',
    '请选择主要采购市场': '请选择主要采购市场',
    '请输入预计月采购量': '请输入预计月采购量',
    '请输入公司邮箱': '请输入公司邮箱',
    '请输入公司电话': '请输入公司电话',
    '请输入公司网站': '请输入公司网站',
    '请输入办公地址': '请输入办公地址',
    '请上传公司营业执照': '请上传公司营业执照',
    '请上传进出口贸易许可证': '请上传进出口贸易许可证',
    '请上传银行账户证明': '请上传银行账户证明'
},
	'solution4':{
		'txt1':'让精准传感·驱动全球智造未来',
		'txt2':'在工业自动化、无人机导航、机器人控制、汽车电子等高精度领域，陀螺仪的选型直接关系设备性能与可靠性。作为专业的工业品跨境贸易平台，我们深知客户在选品中面临的挑战：',
		'txt3':'参数复杂：量程、零偏稳定性、噪声等指标如何匹配应用场景',
		'txt4':'环境严苛：高温、冲击、振动条件下如何保障稳定性',
		'txt5':'集成困难：接口兼容性、电路设计如何优化',
		'txt6':'我们的解决方案：基于ASG1000系列MEMS陀螺仪的技术优势，提供"精准选型支持+全流程技术服务"，助您快速实现产品集成与量产',
		'txt7':'ASG1000系列核心优势',
		'txt8':'军工级性能，满足严苛环境',
		'txt9':'高精度：零偏稳定性低至0.5 dph（ASG1100-P5），角度随机游走0.06°/√h，适用于精密导航与姿态控制',
		'txt10':'宽温操作：-55℃至+125℃工作温度，通过GJB 150.3A/4A高低温试验，适应极端工业环境',
		'txt11':'抗冲击振动：4000g冲击耐受，6.06grms振动可靠性，符合GJB 150.18A标准，保障设备长期稳定运行',
		'txt12':'灵活适配，多场景覆盖',
		
		'txt13':'即插即用设计，快速集成',
		'txt14':'标准SPI接口：支持≥2kHz数据速率，兼容主流控制器',
		'txt15':'紧凑封装：11mm×11mm尺寸，适合空间受限设备',
		'txt16':'电路优化指南：提供引脚定义、电容匹配建议（如V4P5外接1μF电容），缩短开发周期',
		
		'txt17':'我们的服务：从选型到量产全程护航',
		'txt18':'精准选型支持',
		'txt19':'场景化匹配：根据您的应用需求（如量程、环境、功耗）推荐最优型号',
		'txt20':'示例：无人机飞控需高动态响应，ASG1500系列100Hz带宽确保实时姿态调整',
		'txt21':'参数对比分析：提供零偏重复性、非线性度等关键指标解读，规避设计风险',
		
		'txt22':'技术赋能',
		'txt23':'参考设计包：含原理图、PCB布局建议、驱动代码，加速开发',
		'txt24':'定制化服务：支持OEM/ODM，优化封装或输出协议，满足特殊需求',
		'txt25':'质量与供应链保障',
		'txt26':'全流程质控：符合GJB 548B、GJB 7952等军用测试标准，100%出厂检验',
		'txt27':'跨境物流无忧：全球仓配网络，提供DDP/DAP服务，确保准时交付',
		
		'txt28':'其他优势',
		'txt29':'技术背书',
		'txt30':'产品源于军工技术团队，10年MEMS传感器研发经验',
		'txt31':'一站式服务',
		'txt32':'从选型咨询、样品测试到批量采购，全程响应',
		'txt33':'数据透明',
		'txt34':'提供第三方测试报告（如振动整流系数、温漂曲线），让客户采购放心',
		
		'tab1': '型号',
		'tab2': '量程',
		'tab3': '关键特性',
		'tab4': '典型应用场景',
		'tab5': '超低噪声、高稳定性',
		'tab6': '无人机定高、精密仪器',
		'tab7': '高带宽（≥100Hz）、强抗振性',
		'tab8': '工业机器人、自动驾驶',
	},
	AddDemand: {
		'xzcgxq': '新增采购需求',
		'bjcgxq': '编辑采购需求',
		'cpmc': '产品名称',
		'cplb': '产品类别',
		'cgsl': '采购数量',
		'dw': '单位',
		'ysje': '预算金额',
		'jhqx': '交货期限',
		'bmjzsj': '报名截止时间',
		'cpzt': '产品主图',
		'cpxjt': '产品细节图',
		'cpfj': '产品附件',
		'cpyqxq': '产品要求详情',
		'qsr': '请输入',
		'qxz': '请选择',
		'tbdxjt': '同步到细节图',
		'tj': '提交',
		'qsrcpmc': '请输入产品名称',
		'qsrcgsl': '请输入采购数量',
		'qsrdw': '请输入单位',
		'qxzcplb': '请选择产品类别',
		'qsrysje': '请输入预算金额',
		'qsrjhqx': '请输入交货期限',
		'qxzbmjzsj': '请选择报价截止时间',
		'qsrcpgxq': '请输入产品规格需求',
		'qsccpzt': '请上传产品主图',
		'qsccpxjt': '请上传产品细节图',
		'xgcg': '修改成功',
		'xzcg': '新增成功',
		'hqcgxqxqsb': '获取采购需求详情失败'
	},
	product: {
		'请先登录后查看产品详情': '请先登录后查看产品详情',
		'请先登录后继续操作': '请先登录后继续操作',
		'提示': '提示',
		'去登录': '去登录',
		'取消': '取消'
	},
};
export default zh_CN;
